import { useQuery } from "@tanstack/react-query"

import { type DemoBanner, fetchDemoBanner } from "@/lib/demoAuth"

/**
 * Subscribe to the demo-banner endpoint.
 *
 * Returns the current state (`enabled`, message key, countdown
 * fields) along with the standard TanStack Query lifecycle flags.
 * The query mirrors the enabled flag to localStorage as a side
 * effect so synchronous code (router beforeLoad) can read it
 * without `await`.
 */
export function useDemoMode() {
  const { data, isLoading, isError } = useQuery<DemoBanner>({
    queryKey: ["demo-banner"],
    queryFn: fetchDemoBanner,
    staleTime: 60_000,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  })

  return {
    enabled: !!data?.enabled,
    bannerData: data,
    isLoading,
    isError,
  }
}
